<div class="panel-wrapper" [class.collapsed]="isCollapsed">
  <ng-content></ng-content>
</div>

@if (collapsible) {
  <div
    matRipple
    class="collapse-toggle"
    [class.collapsed]="isCollapsed"
    (click)="toggleCollapse()"
    tabindex="-1"
    (keyup.enter)="toggleCollapse()"
    (keyup.space)="toggleCollapse()"
    [attr.aria-label]="isCollapsed ? 'Expand panel' : 'Collapse panel'"
  >
    <mat-icon>{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
  </div>
}
